import React, { useState } from "react";
import { user_image, right_arrow } from "../../../images/images";
import "./InfoScreen.css";
import HeadStepper from "../../HeadStepper/HeadStepper";
import { QCSteps, hybridPosvSteps, isNpsSteps, photoVerificationSteps } from "../../../utils/stepperStep";
import LanguageTranslater from "../../HOC/LanguageTranslater";

const SelfieInfoScreen = (props) => {
  const { handleNextButton, translate } = props;
  const [isNps, setIsNps] = useState(localStorage.getItem('isNps'))
  const [isVideoPosv, setIsVideoPosv] = useState(localStorage.getItem('isVideoPosv'))
  const [twoStep, setTwoStep] = useState(localStorage.getItem('twoStep'))
  const [journeyBy, setJourneyBy] = useState(localStorage.getItem('journeyBy'))

  const getSteps = () => {
    if (isNps == 'Y' || journeyBy == 'P') {
      return isNpsSteps
    } else if (isVideoPosv == 'Y') {
      return hybridPosvSteps
    } else if (twoStep == 'Y') {
      return QCSteps
    }
    else {
      return photoVerificationSteps
    }
  }

  return (
    <div className="Info-screen">
      <HeadStepper activeState={0} allSteps={getSteps()} />
      <div className="selfie-info">
        <h2
          className="info-heading"
          dangerouslySetInnerHTML={{
            __html: translate("Position your face inside the circle frame"),
          }}
        ></h2>
        <p
          className="left-aligned-text"
          dangerouslySetInnerHTML={{
            __html: translate(
              "In a bright environment and a plain background, hold your phone about 20-30 cm from your face."
            ),
          }}
        ></p>

        <img className="selfie-placeholder" src={user_image} alt="" />

        <div className="info-messages left-aligned-text">
          <small
            className="left-aligned-text"
            dangerouslySetInnerHTML={{
              __html: translate("Your face data will be added once front camera opens"),
            }}
          ></small>
          <br />
          <small
            className="left-aligned-text m-top "
            dangerouslySetInnerHTML={{
              __html: translate(
                "Please ensure that the front camera is ON and you should be able to view yourself in the camera"
              ),
            }}
          ></small>
          <br />
          <br />

        </div>
        <div
          className={`next-btn-cntnr ${localStorage.getItem("LanguageSelected") == "hin"
            ? "next-btn-hindi"
            : ""
            }`}
        >
          <button className="next-btn" onClick={handleNextButton}>
            <span dangerouslySetInnerHTML={{ __html: translate("Next") }}></span>
            <img className="right-arrow-icon" src={right_arrow} alt="" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageTranslater(SelfieInfoScreen);
